export const defaultMillisecondsToLive = 10000;

export type fetchFunctionType = () => Promise<any>;

export interface IMemoryCache {
    add(key: string, fetchFunction: fetchFunctionType, millisecondsToLive: number | null): void;
    delete(key: string): void;
    get(key: string): Promise<any>;
    getOrAdd(key: string, fetchFunction: fetchFunctionType, millisecondsToLive: number | null): Promise<any>;
    resetCache(): void;
}
